<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-card flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="no-gutters pb-5">
        <v-col cols="12" sm="6" md="6" lg="8" :md="$canRoute('bank-crypto-reg-tab') !== 1 ? 12 : 6" :lg="$canRoute('bank-crypto-reg-tab') !== 1 ? 12 : 8">
          <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here..." single-line solo hide-details></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4" v-if="$canRoute('bank-crypto-reg-tab') === 1">
          <ul>
            <li>
              <v-dialog transition="scale-transition" origin="center center" max-width="460"
                v-model="cryptoCreateDialog" content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile elevation="0" class="text-capitalize custom-hight" color="#039de9" v-bind="attrs"
                    v-on="on">
                    <v-icon> mdi mdi-plus </v-icon>
                    Crypto Account
                  </v-btn>
                </template>
                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                  ">
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Add New Crypto Account
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    You Can Create Your Crypto Account From Here.
                  </v-card-subtitle>
                  <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                    ">
                    <v-row>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Crypto Type</legend>
                          <v-select solo v-model="cryptoInfo.crypto_type" :items="['USDT', 'BTC']"
                            append-icon="mdi-chevron-down" label="Select One" class="custom-select"
                            hide-details></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Currency Name</legend>
                          <v-select v-model="cryptoInfo.network" solo :items="['trc20']" append-icon="mdi-chevron-down"
                            label="Select One" class="custom-select" hide-details></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Wallet Address</legend>
                          <v-text-field v-model="cryptoInfo.address" label="Write Here" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="12">
                        <v-btn tile @click="createCrypto" :loading="loading2" :disabled="loading2" elevation="0"
                          class="text-capitalize btn-account mr-3 px-sm-8" color="greenMain">Confirm</v-btn>
                        <v-btn tile color="#FF567F" @click="cryptoCreateDialog = false" elevation="0"
                          class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </li>

            <li>
              <v-dialog transition="scale-transition" origin="center center" max-width="830" v-model="bankCreateDialog"
                content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile elevation="0" class="text-capitalize custom-hight" color="#039de9" v-bind="attrs"
                    v-on="on">
                    <v-icon> mdi mdi-plus </v-icon>
                    Bank Account
                  </v-btn>
                </template>
                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                  ">
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Add New Bank Account
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    Add new bank account for this user
                  </v-card-subtitle>
                  <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                    ">
                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Account Name*</legend>
                          <v-text-field v-model="bankInfo.bank_acc_name" label="Bank Account Name" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Account Number*</legend>
                          <v-text-field v-model="bankInfo.bank_acc_num" label="Bank Account Number" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Bank Name*</legend>
                          <v-text-field v-model="bankInfo.bank_name" label="Bank Name" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Bank Branch*</legend>
                          <v-text-field v-model="bankInfo.bank_branch" label="Bank Branch" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Bank Address*</legend>
                          <v-text-field v-model="bankInfo.bank_address" label="Bank Address" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Bank Country*</legend>
                          <v-select solo :items="countries" item-text="name" item-value="id" label="Select Country"
                            @change="onCountryChange" v-model="bankInfo.bank_residence_country" class="custom-select"
                            hide-details></v-select>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Bank State*</legend>
                          <v-select solo :items="stateList" item-text="name" item-value="id" label="Select State"
                            @change="onStateChange" v-model="bankInfo.bank_residence_state"
                            :disabled="!bankInfo.bank_residence_country" class="custom-select" hide-details></v-select>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Bank City*</legend>
                          <v-select solo :items="cityList" item-text="name" item-value="id" label="Select City"
                            v-model="bankInfo.bank_residence_city" :disabled="!bankInfo.bank_residence_state"
                            class="custom-select" hide-details></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>IBAN Code*</legend>
                          <v-text-field v-model="bankInfo.bank_iban_num" label="Bank IBAN/Postal Code" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Postal Code*</legend>
                          <v-text-field v-model="bankInfo.bank_postal_code" label="Bank IBAN/Postal Code" single-line
                            solo hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Swift/IFSC Code*</legend>
                          <v-text-field v-model="bankInfo.bank_swift_num" label="Bank Swift Code" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="12">
                        <v-btn tile @click="saveBankAccount" elevation="0"
                          class="text-capitalize btn-account mr-3 px-sm-8" :loading="loading" :disabled="loading"
                          color="greenMain">Confirm</v-btn>
                        <v-btn tile color="#FF567F" @click="bankCreateDialog = false" elevation="0"
                          class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-card>

    <!-- BANK -->
    <v-card class="pa-0 rounded-0 elevation-0">
      <v-sheet class="transactionTable depositTabTable mb-4" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <template>
          <v-card :color="$vuetify.theme.dark ? '#111a26' : '#e1eaf2'">
            <v-card v-for="bank in filteredBanks" :key="bank.id"
              class="pa-0 rounded-0 elevation-0 crypto-bank-card mb-5"
              :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
              <v-row dense>
                <!-- First Column -->
                <v-col cols="12" sm="12" md="6">
                  <h3>
                    <v-img src="@/assets/bank-icon.png"></v-img>
                    <span style="text-transform: uppercase;">{{ bank.bank_name }}</span>
                  </h3>
                  <ul>
                    <li v-for="(item, index) in getFirstColumnItems(bank)" :key="index">
                      <p>
                        <strong>{{ item.label }}:</strong>
                        <span :ref="`${bank.id}_${item.ref}`">{{ item.value }}</span>
                        <v-tooltip top :color="'#111a26'" dark>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" @click="copyName(`${bank.id}_${item.ref}`)">
                              mdi-content-copy
                            </v-icon>
                          </template>
                          <span>Copy</span>
                        </v-tooltip>
                      </p>
                    </li>
                  </ul>
                </v-col>

                <!-- Second Column -->
                <v-col cols="12" sm="12" md="6">
                  <h3>
                    <span class="mt-6 ml-0 mb-3">{{ bank.bank_name }}</span>
                  </h3>
                  <ul>
                    <li v-for="(item, index) in getSecondColumnItems(bank)" :key="index">
                      <p>
                        <strong>{{ item.label }}:</strong>
                        <span :ref="`${bank.id}_${item.ref}`">{{ item.value }}</span>
                        <v-tooltip top :color="'#111a26'" dark>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" @click="copyName(`${bank.id}_${item.ref}`)">
                              mdi-content-copy
                            </v-icon>
                          </template>
                          <span>Copy</span>
                        </v-tooltip>
                      </p>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-card>
          </v-card>
        </template>

        <!-- Snackbar -->
        <v-snackbar color="rgba(3, 157, 233, 0.5)" v-model="snackbar" :timeout="2000" top>
          {{ snackbarText }}
        </v-snackbar>
      </v-sheet>
    </v-card>
    
    <!-- CRYPTO -->
    <v-card class="pa-0 rounded-0 elevation-0">
      <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <template>
          <v-card :color="$vuetify.theme.dark ? '#111a26' : '#e1eaf2'">
            <v-card v-for="(crypto, index) in filteredCryptos" :key="crypto.id"
              class="pa-0 rounded-0 elevation-0 crypto-bank-card mb-5"
              :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
              <v-row dense>
                <!-- First Column -->
                <v-col cols="12" sm="12" md="6">
                  <h3>
                    <v-img src="@/assets/crypto1.png"></v-img>
                    <span style="text-transform: uppercase;">{{ `${crypto.network} (${crypto.crypto_type})` }}</span>
                  </h3>
                  <ul>
                    <li v-for="(item, index) in getFirstColumnCryptoItems(crypto)" :key="index">
                      <p>
                        <strong>{{ item.label }}:</strong>
                        <span :ref="`${crypto.id}_${item.ref}`" style="text-transform: uppercase;">{{ item.value
                        }}</span>
                        <v-tooltip top :color="'#111a26'" dark>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" @click="copyName(`${crypto.id}_${item.ref}`)">
                              mdi-content-copy
                            </v-icon>
                          </template>
                          <span>Copy</span>
                        </v-tooltip>
                      </p>
                    </li>
                  </ul>
                </v-col>

                <!-- Second Column -->
                <v-col cols="12" sm="12" md="6">
                  <h3>
                    <span class="mt-6 ml-0 mb-3" style="visibility: hidden;">USDT</span>
                  </h3>
                  <ul>
                    <li v-for="(item, index) in getSecondColumnCryptoItems(crypto)" :key="index">
                      <p>
                        <strong>{{ item.label }}:</strong>
                        <span :ref="`${crypto.id}_${item.ref}`" style="text-transform: uppercase; display: none;">{{
                          item.value
                        }}</span>
                        <span>{{
                          formatWalletAddress(item.value)
                        }}</span>
                        <v-tooltip top :color="'#111a26'" dark>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" @click="copyName(`${crypto.id}_${item.ref}`)">
                              mdi-content-copy
                            </v-icon>
                          </template>
                          <span>Copy</span>
                        </v-tooltip>
                      </p>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-card>
          </v-card>
        </template>

        <!-- Snackbar -->
        <v-snackbar color="rgba(3, 157, 233, 0.5)" v-model="snackbar" :timeout="2000" top>
          {{ snackbarText }}
        </v-snackbar>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";

import {
  CITIES__ACTIONS,
  CLIENTBANKS__ACTIONS,
  COUNTRIES__ACTIONS,
  STATES__ACTIONS
} from "@/store/action-types";

export default {
  data() {
    return {
      loading: false,
      loading2: false,
      cryptoCreateDialog: false,
      bankCreateDialog: false,
      search: "",
      client_account_id: null,
      bankInfo: {
        bank_name: null,
        bank_acc_name: null,
        bank_acc_num: null,
        bank_iban_num: null,
        bank_swift_num: null,
        bank_postal_code: null,
        bank_residence_country: null,
        bank_residence_state: null,
        bank_residence_city: null,
        bank_address: null,
        bank_branch: null,
      },
      cryptoInfo: {
        crypto_type: null,
        network: null,
        address: null,
      },
      countryList: [],
      stateList: [],
      cityList: [],
      snackbar: false,
      snackbarText: "",
    };
  },

  computed: {
    ...mapState("countries", ["countries"]),
    ...mapState("cities", ["cities"]),
    ...mapState("states", ["states"]),
    ...mapState("clientbanks", ["banks", "cryptos"]),
    ...mapState("admins", ["loggedAdmin"]),

    filteredBanks() {
      if (!this.search) return this.banks;

      const searchTerm = this.search.toLowerCase().trim();

      return this.banks.filter(bank => {
        return (
          bank.bank_name?.toLowerCase().includes(searchTerm) ||
          bank.bank_acc_name?.toLowerCase().includes(searchTerm) ||
          bank.bank_acc_num?.toLowerCase().includes(searchTerm) ||
          bank.bank_iban_num?.toLowerCase().includes(searchTerm) ||
          bank.bank_swift_num?.toLowerCase().includes(searchTerm) ||
          bank.bank_postal_code?.toLowerCase().includes(searchTerm) ||
          bank.bank_address?.toLowerCase().includes(searchTerm) ||
          bank.bank_branch?.toLowerCase().includes(searchTerm) ||
          bank.bankcountry?.toLowerCase().includes(searchTerm) ||
          bank.bankstate?.toLowerCase().includes(searchTerm) ||
          bank.bankcity?.toLowerCase().includes(searchTerm) ||
          bank.bank_residence_code?.toLowerCase().includes(searchTerm) ||
          bank.correspondent_bank?.toLowerCase().includes(searchTerm)
        );
      });
    },
    filteredCryptos() {
      if (!this.search) return this.cryptos;

      const searchTerm = this.search.toLowerCase().trim();

      return this.cryptos.filter(crypto => {
        return (
          crypto.network?.toLowerCase().includes(searchTerm) ||
          crypto.crypto_type?.toLowerCase().includes(searchTerm) ||
          crypto.address?.toLowerCase().includes(searchTerm)
        );
      });
    }
  },
  methods: {
    ...mapActions("countries", [COUNTRIES__ACTIONS.COUNTRIES]),
    ...mapActions("cities", [CITIES__ACTIONS.CITIES]),
    ...mapActions("states", [STATES__ACTIONS.STATES]),
    ...mapActions("clientbanks", [CLIENTBANKS__ACTIONS.CLIENTBANKS, CLIENTBANKS__ACTIONS.CLIENTCRYPTOS, CLIENTBANKS__ACTIONS.CREATECLIENTBANK, CLIENTBANKS__ACTIONS.CREATECLIENTCRYPTO]),

    formatWalletAddress(address) {
      if (!address) return '';
      if (address.length <= 12) return address;

      const first6 = address.substring(0, 6);
      const last6 = address.substring(address.length - 6);
      return `${first6}...${last6}`;
    },

    getFirstColumnItems(bank) {
      return [
        { label: "Bank Name", value: bank.bank_name, ref: "bankName" },
        { label: "Bank Country", value: bank.bankcountry, ref: "bankCountry" },
        { label: "State Province", value: bank.bankstate, ref: "stateProvince" },
        { label: "City", value: bank.bankcity, ref: "city" },
        { label: "Bank Account Name", value: bank.bank_acc_name, ref: "accountName" },
      ];
    },

    getSecondColumnItems(bank) {
      return [
        { label: "Account No. (IBAN)", value: bank.bank_iban_num, ref: "accountNo" },
        { label: "Bank Swift Code", value: bank.bank_swift_num, ref: "swiftCode" },
        { label: "Postal Code", value: bank.bank_postal_code, ref: "postalCode" },
        { label: "Bank Address", value: bank.bank_address, ref: "bankAddress" },
      ];
    },

    getFirstColumnCryptoItems(crypto) {
      return [
        { label: "Currency Name", value: crypto.network, ref: "cryptoName" },
        { label: "Crypto Type", value: crypto.crypto_type, ref: "cryptoType" },
      ];
    },

    getSecondColumnCryptoItems(crypto) {
      return [
        { label: "Wallet Address", value: crypto.address, ref: "cryptoAddress" },
      ];
    },

    copyName(refName) {
      const name = this.$refs[refName][0].textContent.trim();
      this.copyToClipboard(name);
      this.snackbarText = `${name} copied!`;
      this.snackbar = true;
    },

    copyToClipboard(text) {
      const el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },


    async onCountryChange(value) {
      this.selectedState = null;
      this.selectedCity = null;
      this.cityList = [];
      if (value) {
        await this[STATES__ACTIONS.STATES](value);
        this.stateList = this.states;
      }
    },

    async onStateChange(value) {
      this.selectedCity = null;
      if (value) {
        await this[CITIES__ACTIONS.CITIES](value);
        this.cityList = this.cities;
      }
    },

    resetBankForm() {
      this.bankInfo = {
        bank_name: null,
        bank_acc_name: null,
        bank_acc_num: null,
        bank_iban_num: null,
        bank_swift_num: null,
        bank_postal_code: null,
        bank_residence_country: null,
        bank_residence_state: null,
        bank_residence_city: null,
        bank_address: null,
        bank_branch: null,
      }
    },

    resetCryptoForm() {
      this.cryptoInfo = {
        crypto_type: null,
        network: null,
        address: null
      }
    },

    async saveBankAccount() {
      this.loading = true;
      try {
        await this[CLIENTBANKS__ACTIONS.CREATECLIENTBANK]({ ...this.bankInfo, client_account_id: this.client_account_id })
        this.resetBankForm()
      } catch (error) {
        console.log(error)
      } finally {

        setTimeout(() => {
          this.loading = false;
          this.bankCreateDialog = false;
        }, 500);
      }
    },

    async createCrypto() {
      this.loading2 = true;
      try {
        await this[CLIENTBANKS__ACTIONS.CREATECLIENTCRYPTO]({ ...this.cryptoInfo, user_id: this.client_account_id })
        this.resetCryptoForm()
      } catch (error) {
        console.log(error)
      } finally {
        setTimeout(() => {
          this.loading2 = false;
          this.cryptoCreateDialog = false;
        }, 500);
      }
    }
  },

  async created() {
    this.client_account_id = this.$route.params.id
    this[COUNTRIES__ACTIONS.COUNTRIES]();
    this[CLIENTBANKS__ACTIONS.CLIENTBANKS](this.$route.params.id);
    this[CLIENTBANKS__ACTIONS.CLIENTCRYPTOS](this.$route.params.id);
  },
};
</script>